// extracted by mini-css-extract-plugin
export default {"root":"PazzleIcon_root__Vb0xI"};